import React from "react";
import "./assets/styles/global.scss";
import "./assets/styles/bootstrap.scss";
import { permissions } from "./utils/permissions";
import Layout from "./Layout";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Importazioni per MSAL
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from './components/activeDirectory/AuthProvider';
import { msalConfig } from "./components/activeDirectory/msalConfig"; // Importa la configurazione di MSAL


const msalInstance = new PublicClientApplication(msalConfig);
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: permissions.map((item) => {
      return { path: item.href, element: item.component };
    }),
  },
]);

createRoot(document.getElementById("root")).render(
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <RouterProvider router={router} />
  </AuthProvider>
  </MsalProvider>
);
